// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-course-js": () => import("./../../../src/templates/Course.js" /* webpackChunkName: "component---src-templates-course-js" */),
  "component---src-templates-module-js": () => import("./../../../src/templates/Module.js" /* webpackChunkName: "component---src-templates-module-js" */),
  "component---src-templates-slide-js": () => import("./../../../src/templates/Slide.js" /* webpackChunkName: "component---src-templates-slide-js" */)
}

